// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(//at.alicdn.com/t/font_454665_sd41z6zpsqorms4i.css);"]);
// Module
exports.push([module.id, "[class^=\"el-icon-adm\"], [class*=\" el-icon-adm\"] {\n  font-family: \"iconfont\" !important;\n  \n  /* 以下内容参照第三方图标库本身的规则 */\n  font-size: inherit;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n", ""]);
// Exports
module.exports = exports;
